import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/enums/route-path.enum';

@Component({
    selector: 'app-bandi-incentivi-module',
    templateUrl: './bandi-incentivi-module.component.html',
    styleUrls: ['./bandi-incentivi-module.component.scss'],
    standalone: false
})
export class BandiIncentiviModuleComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  goToBandi(): void {
    this.router.navigate([RoutePath.BANDI, RoutePath.TAX_BREAK]);
  }
}
